import { FormGroup, AbstractControl } from '@angular/forms';
import { ElementRef } from '@angular/core';
import { TypedEvent } from './typed-event';
import { IFilterComplete } from '../filter-complete/filter-complete';
import { PatientSearch } from '../model/patient/patient-search';

export interface IFilterComponent {
  formElement: ElementRef;
  form: FormGroup;
  saveFilters(): void;
  setFilters(): boolean;
  getSearchFilters(): SearchFilter[];
  search(): Promise<any>;
}

export class SearchFilter {

  constructor(key: string, value: any, isRequired: boolean) {

    if (value) {
      this.valueView = this.getValue(value);
      this.toolTip = this.getToolTip(value);
    }

    this.value = value;
    this.key = key;
    this.isRequired = isRequired;
  }

  toolTip: string;
  isRequired: boolean;
  onRemove = new TypedEvent<SearchFilter>();
  key: string;
  value: any;
  valueView: string;
  remove() {
    this.onRemove.emit(this);
  }

  private getToolTip(value: any): string {

    if (value && Array.isArray(value)) {
      let ret = '';
      (value as IFilterComplete[]).forEach(item => {
        ret += item.Name + '<br />';
      });
      return ret !== '' ? ret.slice(0, -1) : '';
    } else {
      return this.getValue(value);
    }
  }

  private getValue(value: any): string {

    if (value && Array.isArray(value)) {
      let ret = '';
      const items = <IFilterComplete[]>value;

      if ( items.length > 0 ) {
        ret = items[0].Name;
      }

      if ( items.length > 1 ) {
        ret += `(+${ items.length - 1 } ${ items.length === 2 ? 'otro' : 'otros' })`;
      }

      return ret;
    }

    if (this.isFilterComplete(value)) {
      return (<IFilterComplete>value).Name;
    }

    // armar una interface que sea IFilterEntity que tengas un getFilterText()
    if (this.isPatientSearch(value)) {
      return (<PatientSearch>value).LastName + ', ' + (<PatientSearch>value).FirstName;
    }

    if (typeof value === 'boolean') {
      const bool = <boolean>value;
      return bool ? 'Sí' : 'No';
    }

    if (value instanceof Date) {
      const date = <Date>value;
      const newDate = new Date(date.toUTCString());
      return this.leftPad(newDate.getDate().toString(), 2, '0') + '/'
        + this.leftPad((newDate.getMonth() + 1).toString(), 2, '0') + '/'
        + newDate.getFullYear().toString();
    }

    return value;
  }

  private leftPad(str: string, len: number, ch = '.'): string {
    len = len - str.length + 1;
    return len > 0 ?
      new Array(len).join(ch) + str : str;
  }

  private isPatientSearch(value: any): value is PatientSearch {
    return value.FirstName !== undefined;
  }

  private isFilterComplete(value: any): value is IFilterComplete {
    return value.Name !== undefined;
  }

}

export interface IFilterResponse<T> {
  items: T[];
  searchFilters: SearchFilter[];
}

